<template>

  <!-- form wrap to prevent auto-filling in order search city, state, country -->
  <b-form>
    <b-input-group size="sm" prepend="Name">
        <b-input v-model="address.name"></b-input>
    </b-input-group>
    <b-input-group size="sm" prepend="Address 1">
        <b-input v-model="address.line1"></b-input>
    </b-input-group>

    <b-input-group size="sm" prepend="Address 2">
        <b-input v-model="address.line2"></b-input>
    </b-input-group>

    <b-input-group size="sm" prepend="Tax ID">
        <b-input v-model="address.line3"></b-input>
    </b-input-group>

    <b-input-group size="sm" prepend="City, State, Zip">
        <b-input v-model="address.city"></b-input>
        <b-input v-model="address.state"></b-input>
        <b-input v-model="address.zip"></b-input>
    </b-input-group>

    <b-input-group size="sm" prepend="Country">
        <b-form-select v-model="address.country"
                :options="countries"
                value-field="code"
                text-field="name"></b-form-select>
    </b-input-group>
  </b-form>

</template>

<script>
  import countryList from "../../assets/countryList";
  import AddressMixin from "../../builders/address";

  export default {
      name: "CustomerAddress",
      mixins: [ AddressMixin, countryList ],
      props: [ 'address', 'fullName' ],
      mounted() {        
          if (!this.address) {
              this.address = {
                  name: this.fullName || '',
                  line1: '',
                  line2: '',
                  line3: '',
                  city: '',
                  state: '',
                  zip: '',
                  country: '',
              };
          } else if (!this.address.name) {
                // if address exists but name is empty
                this.$set(this.address, 'name', this.fullName || '');
            }
      },
  }
</script>

<style scoped>
  .input-group-text {
      width: 8rem;
  }
</style>